module.exports = __webpack_public_path__ + "media/images/flags/il-927acd2009fa97938ab4a7ffcb90f3ea.svg";